/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs.ts";
import { courseRegistrationManagementTabsViewModelSchema } from "../courseRegistrationManagementTabsViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs200Schema =
  z.lazy(
    () => courseRegistrationManagementTabsViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryResponse>;
